/*
 * @Author: lvjinbin-at-631455864747 1367100043@qq.com
 * @Date: 2022-11-24 09:02:06
 * @LastEditors: lvjinbin-at-631455864747 1367100043@qq.com
 * @LastEditTime: 2022-12-13 14:44:11
 * @Description: 接口请求模块
 */

import axios from "axios";
import config from "./config";
import md5 from "js-md5";
import { getRandom } from "@/common/utils";
import { Base64 } from "js-base64";
import { captureMessage } from "@sentry/browser";
import {
  getToken,
  removeToken,
  removeUserId,
  removeUserInfo,
} from "@/common/cookies";

const SECRET_KEY1 = "HUJOSUE1OFDJKSAOP3KJLN_FDKJSAP$JFDAP*JFKDASP()JFDKMFMFM";
const __DEV__ = __CUSTOM_ENV__ === "development";

// 这里只区分正式和开发环境
const onlineApi = __BASE_URL__;

// 开发环境使用代理地址，生产环境使用原始地址
config.baseURL = __DEV__ ? "/api" : onlineApi;

if (__DEV__) {
  console.log("axios baseURL===>>>", onlineApi);
  console.log("axios request baseURL", onlineApi, __CUSTOM_ENV__, __BASE_URL__);
}

const service = axios.create(config);

service.interceptors.request.use(
  (config) => {
    const timestamp = parseInt(new Date().valueOf()) / 1000;
    const radom_res = getRandom(0, 100);
    const nonce = String(radom_res) + String(timestamp);
    const md5_str = SECRET_KEY1 + String(timestamp) + nonce;
    const md5_val = md5(md5_str);
    const auth_str = md5_val + "|" + timestamp + "|" + nonce;
    const base_encond = Base64.encode(auth_str);

    const token = getToken();
    if (token) config.headers.token = token;

    config.headers["Content-Type"] = "application/json";
    config.headers["Access-Control-Allow-Headers"] =
      "authapi,token,content-type";
    config.headers.authapi = base_encond;
    // if (__DEV__) {
    //   console.log("请求基础地址:", config.baseURL);
    //   console.log("请求地址:", config.url);
    //   console.log("请求方法:", config.method);
    //   console.log("请求参数:", config.params || config.data);
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 返回状态判断
service.interceptors.response.use(
  (res) => {
    // // 账户被封禁
    // if (res.data.status === 443 && process.client) {
    //     location.href = '/403'
    // }

    const succseeCode = [200];

    const status = res.data.code;

    const isNotAuth = res.data.code === 403;
    const isSuccess = succseeCode.includes(+status);
    // token 已过期 状态码为403
    if (isNotAuth && process.client) {
      removeToken();
      removeUserId();
      removeUserInfo();
      // window.location.href = "/sign-in/?redirect=" + location.pathname;
    }

    let resObj = {};

    if (isSuccess) {
      resObj = {
        status: 200,
        message: res.statusText || "Request Success",
        data: res.data.data,
      };
    } else {
      resObj = {
        status: res.data.code,
        message: res.data.error || "Request Fail",
        data: {},
      };
    }
    return resObj;
  },
  (error) => {
    if (error.message === "cancel") {
      return "Request was canceled";
    }
    captureMessage(error);
    console.error("Request Fail");
    return {
      status: -1,
      message: "Network Error, Please Try Again.",
      data: {},
    };
  }
);

export const CancelToken = axios.CancelToken;

export default service;
